import { PointerSensor, useSensor, useSensors } from '@dnd-kit/core';

/** Drag sensors for a reorderable list: a drag starts after 4px, so a click stays a click. */
export function useReorderSensors() {
  return useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
  );
}
